/* eslint-disable */

const hasIn = (keys, container) => {
    for (var i = 0; i < keys.length; ++i) {
        if (!(keys[i] in container))
            return false;
    }

    return true;
};

const allSatisfied =
    hasIn(['ArrayBuffer', 'Array', 'Map', 'Promise', 'Reflect', 'Set', 'Symbol', 'WeakMap', 'WeakSet'], window) &&
    hasIn(['from', 'of'], Array) &&
    hasIn(['copyWithin', 'fill', 'find', 'findIndex'], Array.prototype) &&
    hasIn(['name'], Function) &&
    hasIn(['acosh', 'hypot', 'imul'], Math) &&
    hasIn(['isNaN', 'isInteger'], Number) &&
    hasIn(['assign', 'getOwnPropertyDescriptors', 'is', 'entries', 'values', 'setPrototypeOf'], Object) &&
    hasIn(['flags'], RegExp.prototype) &&
    hasIn(['fromCodePoint', 'raw'], String) &&
    hasIn(['codePointAt', 'endsWith', 'includes', 'repeat', 'startsWith', 'padStart', 'padEnd'], String.prototype);

export const requirements = {
    allSatisfied
};